import React, { useEffect, useState } from "react";
import { SubmenuControls } from "../SubmenuControls";
import { SectionContainer } from "../SectionContainer";

export const SanitaryRisks = ({data, openMedia, selectedItem, onSelectItem}) => {
    return (
        <main className="main-container" aria-label="Zone de contenu principal">
            <div className="content">
                <SubmenuControls data={data} selectedItem={selectedItem} onSelectedItem={(itemId) => onSelectItem('risques-sanitaires', itemId)}/>
                <div className="subcontent">
                    <SectionContainer selectedItem={selectedItem} title={selectedItem.label} openMedia={openMedia}/>
                </div>
            </div>
        </main>
    )
}